<template>      
    <div id="ubn" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('afterdeparture.Arrival_UBN') }}</h5>
        <p class="text-sm">{{ $t('common.Mandatory_informations') }} *</p>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-8">
            <div class="input-group input-group-static null">
                <label>{{ $t('afterdeparture.Arrival_UBN') }} *</label>
                <select id="arrivalUbnId" v-model="state.arrivalUbnId" class="form-control form-control-default">
                    <option value="">{{ $t('mating.Select_UBN') }}</option>
                    <option v-for="item in state.ubns" :key="item.id" :value="item.id">
                        {{ item.ubn }} - {{ item.locationFullAddressDropDown }}
                    </option>
                </select>
                <span v-if="vrulesUBN$.arrivalUbnId.$error" class="text-sm text-danger">
                    {{ vrulesUBN$.arrivalUbnId.$errors[0].$message }}
                </span>
            </div>
          </div>
        </div>        
        <div class="col-12 col-sm-12 mt-3">
          <button v-on:click="updateUBN" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('afterdeparture.Update_arrival_UBN') }}</button>
        </div>
      </div>
    </div>    
    <div id="animal" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header pb-3">
        <h5>{{ $t('afterdeparture.Animal') }}</h5>        
      </div>
      <div class="card-body pt-0">   
        <div class="row">
          <div class="col-12">
            <div class="mb-4">
              <p class="fw-bold text-sm">{{ $t('afterdeparture.Selected_animals') }} ({{ selectedAnimals.length }})</p>
              <div class="row">
                <div v-for="animal in selectedAnimals" :key="animal.animalId" class="col-md-6 mb-1">
                <div class="card border  text-sm border-success bg-light" @click="toggleSelectAnimal(animal)">                  
                  <span v-html="displayText(animal)"></span>
                  <span 
                    class="text-danger position-absolute top-1 end-0"
                    style="cursor: pointer; font-weight: bold; font-size: 25px; margin-right: 10px;"
                    @click.stop="toggleSelectAnimal(animal)"
                  >
                    ×
                  </span>
                </div>
                </div>
                <p class="text-danger text-sm" v-if="selectedAnimals.length === 0" style="margin-bottom: 2px !important;">
                  {{ $t('common.No_animal_selected') }}
                </p>
                <p class="text-danger text-sm" v-if="vrulesAnimals$.selectedAnimalIds.$error">
                  {{ vrulesAnimals$.selectedAnimalIds.$errors[0].$message }}
                </p>                
              </div>
            </div>
          </div>
          <div class="col-6">
            <!-- Search Input -->
            <div class="input-group input-group-static null">
              <label class="">{{ $t('afterdeparture.Search') }}</label>
              <input
                  v-model="state.searchQueryAnimal"
                  type="text"
                  class="form-control form-control-default"
                  :placeholder="$t('afterdeparture.Search_UBN_studbooknumber_animalnumber_name')"
              >              
            </div>
          </div>
          <div class="col-12 mt-3">
                <!-- Available animals -->
                <p class="fw-bold text-sm">
                    {{ $t('afterdeparture.Available_animals') }}
                </p>

                <div class="available-animals-list">
                    <div class="row">
                        <div
                            v-for="animal in filteredAnimals"
                            :key="animal.animalId"
                            class="col-md-6 mb-1"
                        >
                            <div
                                class="card border text-sm"
                                :class="{'border-success bg-light': isSelectedAnimal(animal.animalId), 'cursor-pointer': true}"
                                @click="toggleSelectAnimal(animal)"
                            >
                                <span v-html="displayText(animal)"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>        
        <div class="col-12 col-sm-12 mt-3">
          <button v-on:click="updateAnimal" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('afterdeparture.Update_arrival_animal') }}</button>
        </div>
      </div>
    </div>
    <div id="ubnto" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header pb-3">
        <h5>{{ $t('afterdeparture.Departure_UBN') }}</h5>
        <p class="mb-0 text-sm">{{ $t('afterdeparture.NB_UBN_outside_studboek') }}</p>        
      </div>
      <div class="card-body pt-0">   
        <div class="row">          
          <div class="col-6">
            <div class="input-group input-group-static null">
                <label>{{ $t('afterdeparture.Departure_UBN') }}</label>
                <select
                    id="departureUbnId"
                    v-model="state.departureUbnId"                    
                    class="form-control form-control-default"
                    :disabled="isDepartureUbnTyped"
                >
                    <option value="">{{ $t('afterdeparture.Select_UBN') }}</option>
                    <option
                        v-for="item in state.departureubns"
                        :key="item.id"
                        :value="item.id"
                    >
                        {{ item.ubn }} - {{ item.locationFullAddressDropDown }}
                        {{ item.shareName ? ' - ' + item.lastName : '' }}
                    </option>
                </select>
            </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('afterdeparture.Departure_UBN_outside_studboek') }}</label>
              <input
                  v-model="state.departureUbn"                  
                  :disabled="isDepartureUbnSelected"
                  type="text"
                  class="form-control form-control-default"
                  :placeholder="$t('afterdeparture.Departure_UBN_outside_studboek')"
              >
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-6">
          </div>
          <div class="col-6">
            <div class="input-group input-group-static null">
              <label class="">{{ $t('afterdeparture.Keeper_name_outside_studboek') }}</label>              
              <input
                  v-model="state.departureKeeper"                  
                  :disabled="isDepartureUbnIdSelected"
                  type="text"
                  class="form-control form-control-default"
                  :placeholder="$t('afterdeparture.Keeper_name_outside_studboek')"
              >
            </div>
          </div>
        </div>
        <div class="row mt-3">          
          <div class="col-12">
            <span v-if="wasValidated && vrulesDepartureUBN$.formLevel?.atLeastOneProvided?.$invalid" class="text-sm text-danger">
              {{ vrulesDepartureUBN$.formLevel?.atLeastOneProvided?.$message }}
            </span>
          </div>          
        </div>
        <div class="col-12 col-sm-12 mt-3">
          <button v-on:click="updateDepartureUBN" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('afterdeparture.Update_arrival_from_UBN') }}</button>
        </div>
      </div>
    </div>
    <div id="date" class="card mt-4 pt-3" data-animation="FadeIn">
      <div class="card-header">
        <h5>{{ $t('afterdeparture.Arrival_Date') }}</h5>           
        <p class="mb-0 text-sm">{{ $t('common.Mandatory_informations') }} *</p>        
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-4">
              <div class="input-group input-group-static null">
                  <label class="">{{ $t('afterdeparture.Arrival_Date') }} *</label>
                  <input v-model="state.departureDate" type="date" :max="todayDate" class="form-control form-control-default" :placeholder="$t('afterdeparture.Arrival_Date')">
                  <span v-if="vrulesDates$.departureDate.$error" class="text-sm text-danger">
                      {{ vrulesDates$.departureDate.$errors[0].$message }}
                  </span>
                  <span v-if="showPastDateWarning" class="text-sm text-danger d-block mt-2">
                    {{ $t('afterdeparture.7_days_message') }}
                  </span>
              </div>
          </div>
          <div class="col-6">
            <div class="input-group input-group-static null">
                <label>{{ $t('afterdeparture.Arrival_reason') }} *</label>                
                <select id="arrivalReasonId" v-model="state.arrivalReasonId" class="form-control form-control-default">
                    <option value="">{{ $t('afterdeparture.Select_reason') }}</option>
                    <option v-for="item in state.arrivalreasons" :key="item.id" :value="item.id">
                        {{ item.name }}
                    </option>
                </select>
                <span v-if="vrulesArrivalReason$.arrivalReasonId.$error" class="text-sm text-danger">
                    {{ vrulesArrivalReason$.arrivalReasonId.$errors[0].$message }}
                </span>
            </div>        
          </div>
        </div> 
        <div class="row">
        <div class="col-12">
          <label class="">{{ $t('animal.Note') }} </label>
          <textarea
            v-model="state.note"
            class="form-control custom-textarea"
            style="border: 1px solid #ced4da;"
            rows="3"                
          ></textarea>
        </div>
      </div>
        <div class="row mt-4">
          <div class="col-12">
            <button v-on:click="updateDate" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('afterdeparture.Update_arrival_date') }}</button>      
          </div>   
        </div>        
      </div>    
    </div>
    <div id="delete" class="card mt-4">
      <div class="card-header">
        <h5>{{ $t('common.Delete') }}</h5>
        <p class="text-sm mb-0">
          {{ $t('common.Once_you_delete_there_is_no_going_back_Please_be_certain') }}
        </p>
      </div>
      <div class="card-body d-sm-flex pt-0">
        <div class="d-flex align-items-center mb-sm-0 mb-4">
          <div>
            <material-switch id="deleteDeparture" name="Delete" v-model="state.deleteDeparture" />
          </div>
          <div class="ms-2">
            <span class="text-dark font-weight-bold d-block text-sm">{{ $t('common.Confirm') }}</span>
            <span class="text-xs d-block">{{ $t('common.Delete_for') }} {{ state.ubn }}.</span>
          </div>
        </div>        
        <button class="btn mb-0 bg-gradient-danger btn-sm null null mb-0 ms-2" type="button" :disabled="!state.deleteDeparture" @click="deleteDeparture" name="button">{{ $t('afterdeparture.Delete_arrival') }}</button>
      </div>
    </div>    
  </template>
  
  <script>
    import MaterialSwitch from "@/components/MaterialSwitch.vue";
    import axios from "axios";
    import { useVuelidate } from "@vuelidate/core";
    import { required, helpers } from "@vuelidate/validators";
    import {
        reactive,
        computed,
        nextTick,
        ref,
        markRaw
    } from "vue";
    import { useI18n } from "vue-i18n";
    import Choices from "choices.js";

    export default {
        name: "DepartureDetailItem",

        setup() {
            const { t } = useI18n();

            const todayDate = new Date().toISOString().split("T")[0];

            /* Main component state */
            const state = reactive({
                gets: {},
                afterdeparture: null,

                id: "",
                type: "",
                groupGuid: "",

                associationId: "",

                // Arrival UBN
                arrivalUbnId: "",

                // Departure UBN
                departureUbnId: "",
                departureUbn: "",
                departureKeeper: "",

                // Animals
                animalIds: "",

                // Date / reason
                departureDate: null,
                arrivalDate: null,
                arrivalReasonId: "",
                note: "",

                // Display UBN
                ubn: "",

                // Lists
                ubns: [],
                departureubns: [],
                arrivalreasons: [],
                males: [],
                animals: [],

                // Delete
                deleteDeparture: false,

                // Animal selection
                selectedAnimalIds: [],
                searchQueryAnimal: ""
            });

            /* Helper */
            const toStr = (value) => {
                return value == null ? "" : String(value);
            };

            /* Departure UBN state */
            const isDepartureUbnTyped = computed(() => {
                return toStr(state.departureUbn).trim().length > 0;
            });

            const isDepartureUbnSelected = computed(() => {
                return !!state.departureUbnId;
            });

            /* Arrival UBN validation */
            const rulesUBN = computed(() => ({
                arrivalUbnId: {
                    required: helpers.withMessage(t("common.Required"), required),
                    isSelected: helpers.withMessage(t("common.Select_a_ubn"), (value) => value !== "")
                }
            }));

            const rulesArrivalReason = computed(() => ({
                arrivalReasonId: {
                    required: helpers.withMessage(t("common.Required"), required)
                }
            }));

            /* Animal display */
            const displayText = (animal) => {
                const parts = [];

                if (animal.animalStudbookNumber) {
                    parts.push(animal.animalStudbookNumber);
                }

                if (animal.animalNumber) {
                    parts.push(animal.animalNumber);
                }

                if (animal.animalName) {
                    parts.push(`(${animal.animalName})`);
                }

                if (animal.arrivalDate) {
                    parts.push(
                        `<span style="color: green">${animal.arrivalDate}</span>`
                    );
                }

                if (animal.breedCode) {
                    parts.push(`(${animal.breedCode})`);
                }

                if (animal.departureReason) {
                    parts.push(animal.departureReason);
                }

                const icon = `
                    <span style="
                        display:inline-flex;
                        align-items:center;
                        justify-content:center;
                        width:18px;
                        height:18px;
                        margin-right:4px;
                        vertical-align:middle;
                    ">
                        <i class="material-symbols-rounded"
                            style="
                                font-size:15px !important;
                                line-height:1 !important;
                                color:#ff9800 !important;
                                display:block;
                            "
                        >output</i>
                    </span>
                `;

                return icon + parts.join(" | ");
            };

            const isSelectedAnimal = (id) => {
                return state.selectedAnimalIds.includes(id);
            };

            const toggleSelectAnimal = (animal) => {
                const animalId = animal.animalId;

                if (!animalId) {
                    return;
                }

                const index = state.selectedAnimalIds.indexOf(animalId);

                if (index > -1) {
                    state.selectedAnimalIds.splice(index, 1);
                } else {
                    state.selectedAnimalIds.push(animalId);
                }
            };

            const selectedAnimals = computed(() => {
                return state.animals.filter((animal) =>
                    state.selectedAnimalIds.includes(animal.animalId)
                );
            });

            const filteredAnimals = computed(() => {
                const search = toStr(state.searchQueryAnimal)
                    .toLowerCase()
                    .trim();

                return state.animals.filter((animal) => {
                    // Don't show already selected animals
                    if (
                        state.selectedAnimalIds.includes(
                            animal.animalId
                        )
                    ) {
                        return false;
                    }

                    // No search = show all available animals
                    if (!search) {
                        return true;
                    }

                    return displayText(animal)
                        .toLowerCase()
                        .includes(search);
                });
            });

            /* Animal validation */
            const rulesAnimals = computed(() => ({
                selectedAnimalIds: {
                    required: helpers.withMessage(t("afterdeparture.Select_at_least_one_animal"), required),
                    minOne: helpers.withMessage(t("afterdeparture.Select_at_least_one_animal"), (value) => Array.isArray(value) && value.length > 0)
                }
            }));

            /* Past date warning */
            const showPastDateWarning = computed(() => {
                if (!state.departureDate) {
                    return false;
                }

                const selectedDate = new Date(state.departureDate);
                const today = new Date();

                const diffInDays = (today - selectedDate) / (1000 * 60 * 60 * 24);
                return diffInDays > 7;
            });

            /* Validation state */
            const wasValidated = ref(false);

            /* Departure UBN validation */
            const vrulesDepartureUBN = computed(() => ({
                departureUbnId: {},
                departureUbn: {},

                formLevel: {
                    atLeastOneProvided: helpers.withMessage(
                        t("afterdeparture.Either_studboek_UBN_or_UBN_outside_studboek_required"),
                        () => !!state.departureUbnId || !!state.departureUbn
                    )
                }
            }));

            /* Date validation */
            const rulesDates = computed(() => ({
                departureDate: { required: helpers.withMessage(t("common.Required"), required)}
            }));

            /* Vuelidate */
            const vrulesUBN$ = useVuelidate(rulesUBN, state);
            const vrulesArrivalReason$ = useVuelidate(rulesArrivalReason, state);
            const vrulesAnimals$ = useVuelidate(rulesAnimals, state);
            const vrulesDepartureUBN$ = useVuelidate(vrulesDepartureUBN, state);
            const vrulesDates$ = useVuelidate(rulesDates, state);
            
            return {
                state,

                isSelectedAnimal,
                toggleSelectAnimal,
                displayText,

                isDepartureUbnSelected,
                isDepartureUbnTyped,

                wasValidated,
                showPastDateWarning,

                selectedAnimals,
                filteredAnimals,

                vrulesUBN$,
                vrulesArrivalReason$,
                vrulesAnimals$,
                vrulesDepartureUBN$,
                vrulesDates$,

                todayDate
            };
        },
        
        data() {
            return {
                choicesInstanceUBN: null,
                choicesInstanceDepartureUBN: null,
                choicesArrivalReason: null,

                // Keep references to change handlers so they can be removed
                // before a Choices instance is recreated.
                choicesChangeHandlers: {}
            };
        },

        components: {
            MaterialSwitch
        },
        
        watch: {
            /* Outside Studboek UBN typed */
            "state.departureUbn"(val) {
                const typed = String(val || "").trim();

                if (typed) {
                    // Outside-studboek UBN is entered. Clear normal UBN selection.
                    if (this.state.departureUbnId) {
                        this.state.departureUbnId = "";
                    }

                    this.disableDepartureDropdown();
                } else {
                    // Outside UBN cleared. Normal UBN can be selected again.
                    this.enableDepartureDropdown();
                }
            },

            "state.departureUbnId"(val) {
                if (val) {
                    // Normal studboek UBN selected. Clear outside UBN.
                    if (this.state.departureUbn) {
                        this.state.departureUbn = "";
                    }

                    // Outside UBN input will automatically become disabled because of :disabled="isDepartureUbnSelected".
                }
            }
        },
                    
        async mounted() {
            // The route ID is the group GUID.
            this.state.id = this.$route.params.id || "";
            this.state.type = this.$route.params.type || "";

            // Preserve it explicitly as groupGuid.
            this.state.groupGuid = this.state.id;

            try {
                this.$store.commit("setShowLoading", true);
                await this.loadAll();
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t("errors.Something_went_wrong");
                this.$showError(`${this.$t("errors.Contact_system_admin")}: ${errorMessage}`
                );
            } finally {
                this.$store.commit("setShowLoading", false);
            }
        },
        beforeUnmount() {
            this.destroyChoices("choicesInstanceUBN", "arrivalUbnId");
            this.destroyChoices("choicesInstanceDepartureUBN", "departureUbnId");
            this.destroyChoices("choicesArrivalReason", "arrivalReasonId");
        },

        methods: {            
            async loadAll() {
                await this.fetchDepartureData(this.state.groupGuid);

                if (!this.state.associationId) {
                    return;
                }

                await this.fetchAllUBN();
                await this.fetchAllDepartureUBN();
                await this.fetchAllAnimal();
                await this.fetchAllArrivalReasons();
            },

            /* Get departure by group */
            async fetchDepartureData(groupGuid) {
                if (!groupGuid) {
                    this.$showError(this.$t("errors.Something_went_wrong"));
                    return;
                }

                try {
                    const response = await axios.get(`afterdeparture/group/${groupGuid}`);
                    this.state.gets = response.data;

                    if (!this.state.gets.success || !this.state.gets.data) {
                        this.$showError(this.$t("errors.Something_went_wrong"));
                        return;
                    }

                    this.state.afterdeparture = this.state.gets.data;

                    const departure = this.state.afterdeparture;
                    this.state.groupGuid = departure.groupGuid || groupGuid;
                    this.state.associationId = departure.associationId || "";

                    this.state.arrivalUbnId = departure.departureToLocationId || "";

                    this.state.departureUbnId = departure.departureFromLocationId || "";
                    this.state.departureUbn = departure.departureToUbn != null ? String(departure.departureToUbn) : "";
                    this.state.departureKeeper = departure.departureKeeper || "";

                    this.state.arrivalReasonId = departure.missingReasonId || "";
                    this.state.note = departure.note || "";
                    this.state.departureDate = departure.arrivalDate || null;
                    this.state.arrivalDate = departure.arrivalDate || null;
                    this.state.animalIds = departure.animalIds || "";

                    if (departure.animalIds) {
                        this.state.selectedAnimalIds = String(departure.animalIds)
                                .split(",")
                                .map((id) => id.trim())
                                .filter((id) => id);
                    } else {
                        this.state.selectedAnimalIds = [];
                    }

                } catch (e) {
                    const errorMessage = e.response?.data?.message || e.message || this.$t("errors.Something_went_wrong");
                    this.$showError(`${this.$t("errors.Contact_system_admin")}: ${errorMessage}`);
                }
            },
            async fetchAllUBN() {
                if (!this.state.associationId) {
                    return;
                }

                try {
                    const response =
                        await axios.get(
                            "Location/getallbyassociationdeparture",
                            {
                                params: { associationId: this.state.associationId}
                            }
                        );

                    const result = response.data;

                    if (result.success && Array.isArray(result.data)) {
                        let availableUbns = result.data;

                        if (this.state.departureUbnId) {
                            availableUbns = availableUbns.filter((item) => item.id !== this.state.departureUbnId);
                        }

                        this.state.ubns = availableUbns;

                        await nextTick();

                        this.initializeChoicesDropdown(
                            {
                                id: "arrivalUbnId",
                                dataList: this.state.ubns,
                                selectedValue: this.state.arrivalUbnId,
                                instanceKey: "choicesInstanceUBN"
                            }
                        );
                    } else {
                        this.$showError(this.$t("errors.Error_fetching_ubns"));
                    }
                } catch (e) {
                    const errorMessage = e.response?.data?.message || e.message || this.$t("errors.Something_went_wrong");
                    this.$showError(`${this.$t("errors.Contact_system_admin")}: ${errorMessage}`);
                }
            },
            async fetchAllDepartureUBN() {
                if (!this.state.associationId) {
                    return;
                }

                try {
                    const response =
                        await axios.get(
                            "Location/getallbyassociationdeparture",
                            {
                                params: { associationId: this.state.associationId}
                            }
                        );

                    const result = response.data;

                    if (result.success && Array.isArray(result.data)) {
                        let availableDepartureUbns = result.data;

                        if (this.state.arrivalUbnId) {
                            availableDepartureUbns = availableDepartureUbns.filter((location) => location.id !== this.state.arrivalUbnId);
                        }

                        this.state.departureubns = availableDepartureUbns;

                        await nextTick();

                        this.initializeChoicesDropdown(
                            {
                                id: "departureUbnId",
                                dataList: this.state.departureubns,
                                selectedValue: this.state.departureUbnId,
                                instanceKey: "choicesInstanceDepartureUBN"
                            }
                        );

                        if (this.state.departureUbn && String(this.state.departureUbn).trim() !== "") {
                            this.disableDepartureDropdown();
                        } else {
                            this.enableDepartureDropdown();
                        }
                    } else {
                        this.$showError(this.$t("errors.Error_fetching_ubns"));
                    }
                } catch (e) {
                    const errorMessage = e.response?.data?.message || e.message || this.$t("errors.Something_went_wrong");
                    this.$showError(`${this.$t("errors.Contact_system_admin")}: ${errorMessage}`);
                }
            },
            async fetchAllAnimal() {
                if (!this.state.associationId) {
                    return;
                }

                try {
                    const response =
                        await axios.get(
                            "Animal/GetAllAfterArrivalAnimal",
                            {
                                params: { associationId: this.state.associationId }
                            }
                        );

                    if (response.data.success) {
                        if (response.data.count > 0 && Array.isArray(response.data.data)) {
                            this.state.animals =
                                response.data.data.sort(
                                    (a, b) => (b.animalNumber ?? "").localeCompare(a.animalNumber ?? "")
                                );
                        } else {
                            this.$showSuccess(this.$t("errors.Success_no_animal_found"));
                        }
                    } else {
                        this.$showError(this.$t("errors.Error_fetching_animals"));
                    }
                } catch (e) {
                    const errorMessage = e.response?.data?.message || e.message || this.$t("errors.Something_went_wrong");
                    this.$showError(`${this.$t("errors.Contact_system_admin")}: ${errorMessage}`);
                }
            },
            async fetchAllArrivalReasons() {
                try {
                    const response =
                        await axios.get(
                            "reference/getreference",
                            {
                                params: { referenceTypeId: "54EE384D-8540-4662-B588-EC05AFD435DB"}
                            }
                        );

                    const result = response.data;

                    if (result.success && Array.isArray(result.data)) {
                        this.state.arrivalreasons = result.data;

                        await nextTick();

                        this.initializeChoicesDropdown(
                            {
                                id: "arrivalReasonId",
                                dataList: this.state.arrivalreasons,
                                selectedValue: this.state.arrivalReasonId,
                                instanceKey: "choicesArrivalReason"
                            }
                        );
                    } else {
                        this.$showError(this.$t("errors.Error_fetching_arrival_reason"));
                    }
                } catch (e) {
                    const errorMessage = e.response?.data?.message || e.message || this.$t("errors.Something_went_wrong");
                    this.$showError(`${this.$t("errors.Contact_system_admin")}: ${errorMessage}`);
                }
            },
            initializeChoicesDropdown({id, dataList, selectedValue, instanceKey}) {
                const element =
                    document.getElementById(id);

                if (
                    !element ||
                    element.tagName !== "SELECT"
                ) {
                    console.error(
                        `Choices: Invalid or missing select element with ID "${id}".`
                    );

                    return;
                }

                /*
                * Remove old change event handler.
                */
                if (
                    this.choicesChangeHandlers[id]
                ) {
                    element.removeEventListener(
                        "change",
                        this.choicesChangeHandlers[id]
                    );

                    delete this
                        .choicesChangeHandlers[id];
                }

                /*
                * Destroy existing Choices instance.
                */
                if (this[instanceKey]) {
                    try {
                        this[instanceKey].destroy();
                    } catch (e) {
                        console.log(
                            "Choices destroy error",
                            e
                        );
                    }

                    this[instanceKey] = null;
                }

                /*
                * Create Choices instance.
                */
                this[instanceKey] = markRaw(
                    new Choices(element, {
                        searchEnabled: true,
                        itemSelectText: "",
                        shouldSort: false,
                        placeholder: true,
                        placeholderValue:
                            element.options[0]?.text ||
                            ""
                    })
                );

                /*
                * Set selected value.
                *
                * Do not use a fake sentinel value.
                */
                if (
                    selectedValue !== null &&
                    selectedValue !== undefined &&
                    String(selectedValue).trim() !== ""
                ) {
                    const selected =
                        String(selectedValue);

                    const exists =
                        dataList.some(
                            (item) =>
                                String(item.id) ===
                                selected
                        );

                    if (exists) {
                        this[instanceKey]
                            .setChoiceByValue(
                                selected
                            );
                    }
                }

                /*
                * Keep Vue state synchronized with Choices.
                */
                const changeHandler = (event) => {
                    const value =
                        event.target.value || "";

                    if (id === "arrivalUbnId") {
                        this.state.arrivalUbnId = value;
                    }

                    if (id === "departureUbnId") {
                        this.state.departureUbnId = value;
                    }

                    if (id === "arrivalReasonId") {
                        this.state.arrivalReasonId = value;
                    }
                };

                this.choicesChangeHandlers[id] = changeHandler;

                element.addEventListener("change", changeHandler);

                /*
                * Set initial disabled state
                * for Departure UBN.
                */
                if (id === "departureUbnId") {
                    const outsideUbn = String(this.state.departureUbn || "").trim();

                    if (outsideUbn) {
                        this[instanceKey].disable();
                    } else {
                        this[instanceKey].enable();
                    }
                }
            },

            /* Disable Departure UBN dropdown */
            disableDepartureDropdown() {
                const inst = this.choicesInstanceDepartureUBN;

                if (!inst) {
                    return;
                }

                /*
                * Normal UBN must be empty when
                * outside UBN is being used.
                */
                this.state.departureUbnId = "";

                try {
                    inst.removeActiveItems();
                } catch (e) {
                    console.log("Choices removeActiveItems error", e);
                }

                inst.disable();
            },

            /* Enable Departure UBN dropdown */
            enableDepartureDropdown() {
                const inst = this.choicesInstanceDepartureUBN;
                if (!inst) {
                    return;
                }
                inst.enable();
            },

            /* Update Arrival UBN */
            async updateUBN() {
                try {
                    this.$store.commit("setShowLoading", true);

                    await this.vrulesUBN$.$validate();

                    if (this.vrulesUBN$.$error) {
                        return;
                    }

                    const response =
                        await axios.put(
                            "afterdeparture/updateubnto",
                            {
                                groupGuid: this.state.groupGuid,
                                arrivalUbnId:this.state.arrivalUbnId
                            }
                        );

                    this.state.gets = response.data;

                    if (this.state.gets.success) {
                        this.$showSuccess(this.$t("errors.Success_arrival_ubn_updated_successfully"));

                        /* Refresh the data without changing the route.*/
                        await this.fetchDepartureData(this.state.groupGuid);
                        await this.$nextTick();

                        await this.fetchAllUBN();
                        await this.$nextTick();

                    } else {
                        this.$showError(this.$t("errors.Contact_system_admin"));
                    }
                } catch (e) {
                    const errorMessage = e.response?.data?.message || e.message || this.$t("errors.Something_went_wrong");
                    this.$showError(`${this.$t("errors.Contact_system_admin")}: ${errorMessage}`);
                } finally {
                    this.$store.commit("setShowLoading", false);
                }
            },

            /* Update animals */
            async updateAnimal() {
                try {
                    this.$store.commit("setShowLoading", true);

                    await this.vrulesAnimals$.$validate();

                    if (this.vrulesAnimals$.$error) {
                        return;
                    }

                    /* Always send a comma-separated string. */
                    const animalIds = this.state.selectedAnimalIds.join(",");

                    const response =
                        await axios.put(
                            "afterdeparture/updateanimal",
                            {
                                groupGuid: this.state.groupGuid,
                                animalIds: animalIds
                            }
                        );

                    this.state.gets = response.data;

                    if (this.state.gets.success) {
                        this.$showSuccess(this.$t("errors.Success_arrival_animal_updated_successfully"));
                        
                        /* Refresh the data without changing the route.*/
                        await this.fetchDepartureData(this.state.groupGuid);
                        await this.$nextTick();

                        await this.fetchAllAnimal();
                        await this.$nextTick();
                    } else {
                        this.$showError(this.$t("errors.Contact_system_admin"));
                    }
                } catch (e) {
                    const errorMessage = e.response?.data?.message || e.message || this.$t("errors.Something_went_wrong");
                    this.$showError(`${this.$t("errors.Contact_system_admin")}: ${errorMessage}`);
                } finally {
                    this.$store.commit("setShowLoading", false);
                }
            },

            /* Update Departure from UBN */
            async updateDepartureUBN() {
                try {
                    this.$store.commit("setShowLoading", true);
                    this.wasValidated = true;

                    const valid = await this.vrulesDepartureUBN$.$validate();

                    if (!valid) {
                        return;
                    }

                    const typed = this.state.departureUbn?.trim() || "";

                    const departureUbnNum = typed.length > 0 ? Number(typed): null;

                    /* Outside UBN must be numeric.*/
                    if (typed && Number.isNaN(departureUbnNum)) {
                        this.$showError(this.$t("errors.Please_enter_a_valid_numeric_UBN"));
                        return;
                    }

                    const response =
                        await axios.put(
                            "afterdeparture/updateubnfrom",
                            {
                                groupGuid: this.state.groupGuid,
                                departureUbnId: this.state.departureUbnId || null,
                                departureUbn: departureUbnNum,
                                departureKeeper: this.state.departureKeeper
                            }
                        );

                    this.state.gets = response.data;

                    if (this.state.gets.success) {
                        this.$showSuccess(this.$t("errors.Success_arrival_from_ubn_updated_successfully"));

                        /* Refresh the data without changing the route.*/
                        await this.fetchDepartureData(this.state.groupGuid);
                        await this.$nextTick();

                        await this.fetchAllDepartureUBN();
                        await this.$nextTick();

                    } else {
                        this.$showError(this.$t("errors.Contact_system_admin"));
                    }
                } catch (e) {
                    const errorMessage = e.response?.data?.message || e.message || this.$t("errors.Something_went_wrong");
                    this.$showError(`${this.$t("errors.Contact_system_admin")}: ${errorMessage}`);
                } finally {
                    this.$store.commit("setShowLoading", false);
                }
            },

            /* Update departure date */
            async updateDate() {
                try {
                    this.$store.commit(
                        "setShowLoading",
                        true
                    );

                    const dateValid = await this.vrulesDates$.$validate();
                    const reasonValid = await this.vrulesArrivalReason$.$validate();

                    if (!dateValid || !reasonValid) {
                        return;
                    }

                    const response =
                        await axios.put(
                            "afterdeparture/updatedate",
                            {
                                groupGuid: this.state.groupGuid,
                                departureDate: this.state.departureDate,
                                arrivalReasonId: this.state.arrivalReasonId,
                                note: this.state.note
                            }
                        );

                    this.state.gets = response.data;

                    if (this.state.gets.success) {
                        this.$showSuccess(this.$t("errors.Success_arrival_date_updated_successfully"));

                        /* Refresh the data without changing the route.*/
                        await this.fetchDepartureData(this.state.groupGuid);
                        await this.$nextTick();

                        await this.fetchAllArrivalReasons();
                        await this.$nextTick();
                    } else {
                        this.$showError(this.$t("errors.Contact_system_admin"));
                    }
                } catch (e) {
                    const errorMessage = e.response?.data?.message || e.message || this.$t("errors.Something_went_wrong");
                    this.$showError(`${this.$t("errors.Contact_system_admin")}: ${errorMessage}`);
                } finally {
                    this.$store.commit("setShowLoading", false);
                }
            },

            /* Confirm delete */
            confirmDelete() {
                console.log("confirmDelete called");
                this.state.deleteDeparture = !this.state.deleteDeparture;
                console.log("deleteDeparture:", this.state.deleteDeparture);    
            },

            /* Delete departure */
            deleteDeparture() {
                if (this.state.deleteDeparture) {
                    this.deleteDeparture1(
                        this.state.groupGuid
                    );
                }
            },

            /* Delete arrival by group */
            async deleteDeparture1(groupGuid) {
                if (!groupGuid) {
                    return;
                }

                try {
                    this.$store.commit("setShowLoading", true);

                    const response = await axios.delete("afterdeparture/group/" + groupGuid);
                    this.state.gets = response.data;

                    if (this.state.gets.success) {
                        this.$showSuccess(this.$t("errors.Success_arrival_deleted_successfully"));

                        this.$router.push("/afterdeparture");
                    } else {
                        this.$showError(this.$t("errors.Contact_system_admin"));
                    }
                } catch (e) {
                    const errorMessage = e.response?.data?.message || e.message || this.$t("errors.Something_went_wrong");
                    this.$showError(`${this.$t("errors.Contact_system_admin")}: ${errorMessage}`);
                } finally {
                    this.$store.commit("setShowLoading", false);
                }
            },

            /* Destroy Choices instance */
            destroyChoices(instanceKey, id) {
                const element = document.getElementById(id);

                /* Remove change event handler. */
                if (element && this.choicesChangeHandlers[id]) {
                    element.removeEventListener("change", this.choicesChangeHandlers[id]);
                    delete this.choicesChangeHandlers[id];
                }

                /* Destroy Choices instance. */
                if (this[instanceKey]) {
                    try {
                        this[instanceKey].destroy();
                    } catch (e) {
                        console.log("Choices destroy error", e);
                    }
                    this[instanceKey] = null;
                }
            }
        }
    };
    </script>
  <style scoped>
    .card {
        transition: background-color 0.2s ease-in-out;
        cursor: pointer;
        position: relative;
        padding: 10px !important;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .bg-light {
        background-color: #f9f9f9 !important;
    }
    .border-success {
        border-color: #28a745 !important;
    }

    .available-animals-list {

        max-height: 400px;
        overflow-y: auto;
        overflow-x: hidden;

        padding: 6px 12px 6px 4px;
        border: 1px solid #e9ecef;
        border-radius: 10px;
        background: #fafafa;

        scrollbar-width: thin;
        scrollbar-color: #adb5bd transparent;
    }

    .available-animals-list::-webkit-scrollbar {
        width: 7px;
    }

    .available-animals-list::-webkit-scrollbar-track {
        background: transparent;
        border-radius: 10px;
    }

    .available-animals-list::-webkit-scrollbar-thumb {
        background: #adb5bd;
        border-radius: 10px;
    }

    .available-animals-list::-webkit-scrollbar-thumb:hover {
        background: #6c757d;
    }
</style>